import React from 'react';
import { X, Download, Printer } from 'lucide-react';

const ReceiptModal = ({ receiptData, onClose }) => {
  if (!receiptData) return null;

  const formatDate = (dateStr) => {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('da-DK', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatDateTime = (isoStr) => {
    if (!isoStr) return '';
    const date = new Date(isoStr);
    return date.toLocaleString('da-DK', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '1rem'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '10px',
          maxWidth: '700px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header - Hide on print */}
        <div 
          className="no-print"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1.5rem',
            borderBottom: '1px solid #e5e5e5'
          }}
        >
          <h2 style={{ fontSize: '1.5rem', margin: 0 }}>Booking Receipt</h2>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button
              onClick={handlePrint}
              style={{
                padding: '0.5rem',
                background: '#7c6f5e',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <Printer size={18} />
              Print
            </button>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <X size={24} />
            </button>
          </div>
        </div>

        {/* Receipt Content */}
        <div style={{ padding: '2rem' }} id="receipt-content">
          {/* Company Header */}
          <div style={{ textAlign: 'center', marginBottom: '2rem', borderBottom: '2px solid #7c6f5e', paddingBottom: '1rem' }}>
            <h1 style={{ fontSize: '2rem', margin: '0 0 0.5rem 0', color: '#7c6f5e' }}>
              JCP Teaching
            </h1>
            <p style={{ margin: 0, color: '#666' }}>Booking Receipt</p>
          </div>

          {/* Receipt Details */}
          <div style={{ marginBottom: '2rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
              <div>
                <p style={{ fontSize: '0.85rem', color: '#666', margin: '0 0 0.25rem 0' }}>Receipt ID:</p>
                <p style={{ fontWeight: 500, margin: 0 }}>{receiptData.receipt_id}</p>
              </div>
              <div>
                <p style={{ fontSize: '0.85rem', color: '#666', margin: '0 0 0.25rem 0' }}>Issue Date:</p>
                <p style={{ fontWeight: 500, margin: 0 }}>{formatDateTime(receiptData.created_at)}</p>
              </div>
            </div>

            {/* Customer Info */}
            <div style={{ background: '#f5f5f5', padding: '1rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
              <h3 style={{ fontSize: '1rem', margin: '0 0 0.75rem 0' }}>Customer Information</h3>
              <p style={{ margin: '0.25rem 0' }}><strong>Name:</strong> {receiptData.client_name}</p>
              <p style={{ margin: '0.25rem 0' }}><strong>Email:</strong> {receiptData.client_email}</p>
            </div>

            {/* Booking Details */}
            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ fontSize: '1rem', margin: '0 0 0.75rem 0' }}>Booking Details</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr style={{ borderBottom: '1px solid #e5e5e5' }}>
                    <td style={{ padding: '0.75rem 0', color: '#666' }}>Instructor:</td>
                    <td style={{ padding: '0.75rem 0', textAlign: 'right', fontWeight: 500 }}>{receiptData.instructor_name}</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #e5e5e5' }}>
                    <td style={{ padding: '0.75rem 0', color: '#666' }}>Date:</td>
                    <td style={{ padding: '0.75rem 0', textAlign: 'right', fontWeight: 500 }}>{formatDate(receiptData.booking_date)}</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #e5e5e5' }}>
                    <td style={{ padding: '0.75rem 0', color: '#666' }}>Time:</td>
                    <td style={{ padding: '0.75rem 0', textAlign: 'right', fontWeight: 500 }}>{receiptData.booking_time}</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #e5e5e5' }}>
                    <td style={{ padding: '0.75rem 0', color: '#666' }}>Duration:</td>
                    <td style={{ padding: '0.75rem 0', textAlign: 'right', fontWeight: 500 }}>{receiptData.duration_minutes} minutes</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #e5e5e5' }}>
                    <td style={{ padding: '0.75rem 0', color: '#666' }}>Type:</td>
                    <td style={{ padding: '0.75rem 0', textAlign: 'right', fontWeight: 500 }}>
                      {receiptData.booking_type === 'online' ? 'Pivo Online' : 
                       receiptData.booking_type === 'greven' ? 'JCP Teaching, Greven' : 
                       receiptData.booking_type}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Payment Summary */}
            <div style={{ background: '#f5f5f5', padding: '1rem', borderRadius: '8px' }}>
              <h3 style={{ fontSize: '1rem', margin: '0 0 0.75rem 0' }}>Payment Summary</h3>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                <span style={{ color: '#666' }}>Lesson Fee:</span>
                <span style={{ fontWeight: 500 }}>€{receiptData.price.toFixed(2)}</span>
              </div>
              <div style={{ borderTop: '2px solid #7c6f5e', paddingTop: '0.75rem', marginTop: '0.75rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>Total Paid:</span>
                  <span style={{ fontSize: '1.3rem', fontWeight: 600, color: '#7c6f5e' }}>€{receiptData.price.toFixed(2)}</span>
                </div>
              </div>
              <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem', borderTop: '1px solid #ddd' }}>
                <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>
                  <strong>Payment Method:</strong> {receiptData.payment_method === 'online' ? 'Online Payment' : 'In-Person'}
                </p>
                <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.85rem' }}>
                  <span style={{ 
                    padding: '0.25rem 0.5rem', 
                    borderRadius: '4px',
                    background: '#e8f5e9',
                    color: '#2e7d32',
                    fontWeight: 500
                  }}>
                    ✓ Payment Confirmed
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{ textAlign: 'center', marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid #e5e5e5' }}>
            <p style={{ margin: '0.25rem 0', fontSize: '0.85rem', color: '#666' }}>
              Thank you for choosing JCP Teaching!
            </p>
            <p style={{ margin: '0.25rem 0', fontSize: '0.75rem', color: '#999' }}>
              For questions, please contact us at info@jcp-teaching.com
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body * {
            visibility: hidden;
          }
          #receipt-content, #receipt-content * {
            visibility: visible;
          }
          #receipt-content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default ReceiptModal;
